<template>
    <div>
        <br>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form class="form-inline">
                    <input class="form-control mr-sm-2"
                           type="search"
                           placeholder="รหัส"
                           v-on:keyup.enter="searchCheckList"
                           v-model="search.material_id"
                           aria-label="Search"/>
                    <input class="form-control mr-sm-2"
                           type="search"
                           v-model="search.date"
                           v-on:keyup.enter="searchCheckList"
                            placeholder="วันที่ตรวจสอบ"
                            onfocus="(this.type='date')"
                            onblur="(this.type='text')"
                            aria-label="Search"/>
                    <button class="btn btn-success my-2 my-sm-0"
                            @click="searchCheckList"
                            type="button">
                        <icon name="search"></icon>
                        ค้นหา
                    </button>&nbsp
                </form>
            </div>
        </nav>
        <div class="col-12 table-responsive">
            <table class="table table-bordered text-center">
                <thead>
                <tr>
                    <th scope="col">ลำดับ</th>
                    <th scope="col">รหัสวัตถุดิบ</th>
                    <th scope="col">วันที่ตรวจสอบ</th>
                    <th scope="col">กะ</th>
                    <th scope="col">ผู้บันทึก</th>
                    <th scope="col">คงเหลือในโกดัง</th>
                    <th scope="col">ค้างใน PO</th>
                    <th scope="col">สถานะ</th>
                    <th scope="col">สั่งซื้อ</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(data,index) in checklist">
                    <td>{{++index}}</td>
                    <td>{{data.material.code}}</td>
                    <td>{{data.checked_date}}</td>
                    <td>{{data.shift.name}}</td>
                    <td>{{data.user.name}}</td>
                    <td>{{data.material_remain}}</td>
                    <td>{{data.po_quantity}}</td>
                    <td>{{data.status_name}}</td>
                    <td>
                        <a @click="CheckListOrder(data.id)">
                            <icon name="shopping-basket"></icon>
                        </a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <br/>
        <div v-if="checklist.length > 0">
            <vue-pagination :pagination="dataPaginate"
                            @paginate="getCheckListPage">
            </vue-pagination>
        </div>
        <!--<pre class="alert alert-primary">{{ checklist }}</pre>-->
        <br>
        <b-modal
                hide-footer
                ref="import_data"
                centered
                id="import"
                title="สั่งซื้อวัตถุดิบ">
            <check-list-modal @submit="createPreOrder">
            </check-list-modal>
        </b-modal>
        <br>
    </div>
</template>

<script>
    import { mapState } from "vuex";
    import CheckListModal from "./CheckOrderModal";
    import VuePagination from "../../Pagination";
    export default {
        components: {
            VuePagination,
            CheckListModal},
        name: "checked-list",
        data(){
          return {
              search :{
                  material_id : "",
                  date : ""
              },
              event_submit : false,
          }
        },
        created(){
            this.$store.dispatch('CheckList/get');
        },
        computed:{
            ...mapState({
                checklist : state=>{
                    return state.CheckList.table;
                },
                dataPaginate:state=>{
                    return state.CheckList.dataPaginate;
                },
            })
        },
        methods:{
            showCheckListModal(){
                this.$refs.import_data.show();
            },
            hideCheckListModal(){
                this.$refs.import_data.hide();
            },
            CheckListOrder(id){
                this.$store.dispatch("CheckList/show",id).then(()=>{
                    this.showCheckListModal();
                });
            },
            createPreOrder(submitData){
                if(submitData=="cancel"){
                    this.hideCheckListModal();
                }else{
                    this.$store.dispatch('PreOrder/create',submitData).then(()=>{
                        this.hideCheckListModal();
                        this.goToPreOrderPage();
                    })
                }
            },
            goToPreOrderPage(){
                this.$router.push({name : 'pre-order'})
            },
            searchCheckList(){
                this.event_submit = true
                this.$store.dispatch('CheckList/search',{
                    material_id : this.search.material_id,
                    date : this.search.date
                });
            },
            getCheckListPage(){
                const page = this.dataPaginate.current_page;
                //paginate search
                if(this.event_submit){
                    this.$store.dispatch('CheckList/search',{
                        page : page,
                        material_id : this.search.material_id,
                        date : this.search.date
                    });
                }else{
                    //paginate get data
                    this.$store.dispatch('CheckList/get',page)
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @media only screen and (max-width: 760px),
    (min-device-width: 768px) and (max-device-width: 1024px) {
        /* Force table to not be like tables anymore */
        table,
        thead,
        tbody,
        th,
        td,
        tr {
            display: block;
        }

        /* Hide table headers (but not display: none;, for accessibility) */
        thead tr {
            position: absolute;
            top: -9999px;
            left: -9999px;
        }

        tr {
            border: 1px solid #ccc;
        }

        td {
            /* Behave  like a "row" */
            border: none;
            border-bottom: 1px solid #eee;
            position: relative;
            padding-left: 50%;
        }

        td:before {
            /* Now like a table header */
            position: absolute;
            /* Top/left values mimic padding */
            top: 6px;
            left: 6px;
            width: 45%;
            padding-right: 10px;
            white-space: nowrap;
        }
        td:nth-of-type(1):before {
            content: "ลำดับ";
        }
        td:nth-of-type(2):before {
            content: "รหัสวัตถุดิบ";
        }
        td:nth-of-type(3):before {
            content: "วันที่ตรวจสอบ";
        }
        td:nth-of-type(4):before {
            content: "กะ";
        }
        td:nth-of-type(5):before {
            content: "ผู้บันทึก";
        }
        td:nth-of-type(6):before {
            content: "คงเหลือในโกดัง";
        }
        td:nth-of-type(7):before {
            content: "ค้างใน PO";
        }
        td:nth-of-type(8):before {
            content: "สถานะ";
        }
        td:nth-of-type(9):before {
            content: "สั่งซื้อ";
        }
    }
</style>